import { createReducer } from '@reduxjs/toolkit';
import InitialState from '../reducers/initial-state';
import * as CaseConfigActions from '../actions/case-config';
import { loadStates } from '@codametrix/ui-common';
import {
  caseConfigFieldsBySection,
  caseConfigFormLabels
} from './state/case-config/case-config';
import { CMxComponents } from '@codametrix/ui-components/src/types';
import { formErrors } from '../stubs/form-errors';
import { logout } from '../actions/ui';
import { jumpContext } from '../actions/contexts.action';

const { LOAD_STATES } = loadStates;

const reducer = createReducer(InitialState.caseConfig, builder => {
  builder.addCase(logout.type, () => ({ ...InitialState.caseConfig }));
  builder.addCase(jumpContext.pending.type, () => ({ ...InitialState.caseConfig }));

  builder.addCase(CaseConfigActions.listCaseConfigurations.pending, state => ({
    ...state,
    loadState: LOAD_STATES.initial,
    formErrors: formErrors.noErrors
  }));

  builder.addCase(CaseConfigActions.listCaseConfigurations.rejected, state => ({
    ...state,
    loadState: LOAD_STATES.failed
  }));

  builder.addCase(CaseConfigActions.listCaseConfigurations.fulfilled, (state, action) => ({
    ...state,
    dataObject: action.payload,
    loadState: LOAD_STATES.done
  }));

  builder.addCase(CaseConfigActions.saveCaseConfiguration.rejected, (state, action) => ({
    ...state,
    formErrors: (action.payload as any)?.errors
  }));

  builder.addCase(CaseConfigActions.saveCaseConfiguration.fulfilled, (state, action) => {
    const key = action.payload.configurationKey;
    const val = action.payload.configurationValues[0].configurationValue;

    return {
      ...state,
      dataObject: { ...state.dataObject, [key]: val }
    };
  });

  builder.addCase(CaseConfigActions.syncActions.reduxSaveCaseConfigs, (state, action) => ({
    ...state,
    caseConfigs: action.payload
  }));

  builder.addCase(CaseConfigActions.syncActions.selectConfigSection, (state, action) => {
    const tabListItems = state.tabListItems.map(tab => ({
      ...tab,
      active: tab.id === action.payload ? true : false
    }));
    return {
      ...state,
      section: action.payload,
      tabListItems
    };
  });

  builder.addCase(CaseConfigActions.loadCaseConfigOptions.fulfilled, (state, action) => {
    const { formDef } = state;
    const defaultFields = caseConfigFieldsBySection[action.meta.arg.section];

    const fields = defaultFields.map(field => {
      const options = action.payload[field.key] || field.options || [];
      return {
        ...field,
        options: options
      };
    });

    const form: CMxComponents.FormDefintion = {
      fieldGroups: [
        {
          label: caseConfigFormLabels[action.meta.arg.section],
          fields
        }
      ],
      buttons: formDef.buttons
    };

    return {
      ...state,
      formDef: form
    };
  });
});

export default reducer;
